import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from 'rxjs';
import { UploadedImageInformation } from '../../api/models/placardConfirmationSession';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';
import { ApiErrorCode, HTML_HEADER, RouteURLConstants, ServiceURLConstants, UPS_PICKUP_POINT } from '../../constants/upplm.constants';
import { PlacardConfirmationStatusResponse } from '../../interface/upplm.placardconfirmation';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpplmApiService } from '../../services/upplm.api.services';
import { UpsCommonService } from '../../services/upplm.common.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { BreadcrumbItem } from '../commonComponent/ups-breadcrumb/breadcrumbItem';

@Component({
    selector: 'placardconfirmed',
    template: require('./placardConfirmed.component.html')
})

export class PlacardConfirmedComponent implements OnInit, OnDestroy {
    public placardID: string = '';
    public startDate: string = '';
    startDateFormat: Date;
    public phoneNumber: string = '';
    public isConfirmed: boolean = false;
    public isInitialLoadding: boolean = true;
    public paramsUrl: string = '?loc=en_US&placardid=';
    public sessionData: SessionResponse;
    public apiResponse: PlacardConfirmationStatusResponse;
    public comesFromFlow: boolean = false;
    subscription: Subscription;

    //--------------------------------------------------
    //Variables for Page Title and Header
    //--------------------------------------------------
    pageTitleText = '';
    ManageUPSText = '';
    public breadCrumbItems: BreadcrumbItem[] = [];
    confirmedThankYouMessage: string = '';
    globalRegion: string = 'NA';

    constructor(private router: Router,
        public _activatedRoute: ActivatedRoute,
        private _commonService: UpsCommonService,
        private _apiService: UpplmApiService,
        private _sessionService: UpplmSessionService,
        private _commonServiceCommon: UpsCommonService,
        private location: Location,
        private _translateData: TranslateDataPipe) { }

    ngOnInit() {
        this.backBrowser();
        this.pageTitleText = this._translateData.transform('upplm.placardlocationdetails.confirmplacardtitle');
        this.confirmedThankYouMessage = this.getConfirmedThankYouMessage();
        this.ManageUPSText = HTML_HEADER.MANAGE_UPPLOCATION_HEADER;
        this.isInitialLoadding = true;

        this.placardID = this._activatedRoute.snapshot.queryParamMap.get('placardid')
        if (this.placardID === null) {
            this.placardID = this._commonService.getUrlParameter("placardid");
        }
        this.placardID = this.placardID.toUpperCase();

        if (this.placardID === '') {
            this.placardID = this._sessionService.sessionData.placardID;
        }

        this.sessionData = this._sessionService.sessionData;


        if (this.sessionData.backBrowserPage && this.sessionData.backBrowserPage === 'PlacardConfirmed') {
            this.renderUIforNoSessionData();
        }
        else {
            let request = this.createSessionRequest();
            let requestImg: UploadedImageInformation = new UploadedImageInformation();
            if (request.placardConfirmation) {
                requestImg = request.placardConfirmation.placardImage;
                delete request.placardConfirmation.placardImage;
            }
            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), request).subscribe((response: SessionResponse) => {
                if (response.placardConfirmation) { //There is session data
                    response.placardConfirmation.placardImage = requestImg;
                    this._sessionService.mapSessionResponse(response);
                    this.sessionData = response;
                    this._apiService.PostServiceAPI(this._commonService.createURL(ServiceURLConstants.GET_PLACARD_CONFIRMATION_STATUS, ApiErrorCode.GET_PLACARD_CONFIRMATION_STATUS), this.placardID).subscribe((response: PlacardConfirmationStatusResponse) => {
                        this.apiResponse = response;
                        this.comesFromFlow = response.confirmed;
                        this.processConfirmedResponse(response);
                    });
                }
                else { //No session Data
                    this.renderUIforNoSessionData();                    
                }
            });
        }
    }

    getConfirmedThankYouMessage(): string {
        const thankYouMessage = this._translateData.transform('upplm.placardconfirmed.thankyouconfirming');
        return thankYouMessage.replace('%[x]%', UPS_PICKUP_POINT);
    }

    processConfirmedResponse(response: PlacardConfirmationStatusResponse) {
        if (!response.errors) {//Service error
            this.isConfirmed = response.confirmed;
            this.startDate = response.startDate;
            this.startDateFormat = new Date(response.startDate);
            this.phoneNumber = response.phoneNumber;
            this.globalRegion = this._commonService.getRegionCountry(response.placardConfirmationInfo.address.countryCode);
            if (!this.isConfirmed) {//Redirect to placard pending
                this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE + this.paramsUrl.concat(this.placardID));
            }
            this.isInitialLoadding = false;
        }
        else {
            document.location.href = `https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/pagenotfound.page`;
        }
    }

    renderUIforNoSessionData() {
        if (this.placardID === "") {//No PlacardID
            document.location.href = `https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/pagenotfound.page`;
        }
        else {
            this._apiService.PostServiceAPI(this._commonService.createURL(ServiceURLConstants.GET_PLACARD_CONFIRMATION_STATUS, ApiErrorCode.GET_PLACARD_CONFIRMATION_STATUS), this.placardID).subscribe((response: PlacardConfirmationStatusResponse) => {
                this.apiResponse = response;

                if (this.apiResponse.errors) {//Service error
                    document.location.href = `https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/pagenotfound.page`;
                }
                else {
                    this.isConfirmed = response.confirmed;
                    this.startDate = response.startDate;
                    this.phoneNumber = response.phoneNumber;
                    this.comesFromFlow = false;

                    if (!this.isConfirmed) {//Redirect to placard pending
                        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE + this.paramsUrl.concat(this.placardID));
                    }
                    this.isInitialLoadding = false;
                }

            });
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    createSessionRequest(): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;        
        request.placardID = this.sessionData.placardID;
        request.placardConfirmation = this.sessionData.placardConfirmation;
        request.lastTimeSessionReqired = new Date().toString();
        return request;
    }

    goToDashboard() {
        this._commonServiceCommon.url = '/dashboard';
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
    }

    backBrowser() {
        this.subscription = <Subscription>this.location.subscribe(val => {
            this._sessionService.sessionData.placardConfirmation = null;
            this._sessionService.sessionData.placardID = this.placardID;
            this._sessionService.sessionData.backBrowserPage = 'PlacardConfirmed';
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_PLACARD_CONFIRMED_ROUTE + this.paramsUrl.concat(this.placardID));            
        });
    }

    createBreadCrumb() {
        this.breadCrumbItems = [];
        this.breadCrumbItems.push(new BreadcrumbItem('https://www.ups.com', this._translateData.transform('upplm.breadcrumb.home')));
        this.breadCrumbItems.push(new BreadcrumbItem(`https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/services/tracking.page`,
            this._translateData.transform('upplm.breadcrumb.tracking')));
        this.breadCrumbItems.push(new BreadcrumbItem(`https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/tracking/quantum-view.page`,
            this._translateData.transform('upplm.breadcrumb.manageinboundoutbundshipments')));
        this.breadCrumbItems.push(new BreadcrumbItem('https://www.ups.com/upplm/dashboard',
            `${this._translateData.transform('upplm.breadcrumb.manage')} UPS<sup>${String.fromCharCode(174)}</sup> Pickup Point ${this._translateData.transform('upplm.breadcrumb.locations')}`));
        this.breadCrumbItems.push(new BreadcrumbItem('', this._translateData.transform('upplm.placardlocationdetails.confirmplacardtitle')));
    }
}